import {
  TemplateDefinition,
  TemplateProps,
} from "@/components/AIComponents/ExportablesModal/templates/registry";
import { generatePDF } from "@/utils/generatePDF";

export function getDownloadHandler({
  formData = null,
  selectedExportable,
}: {
  formData: any;
  selectedExportable: TemplateDefinition<any>;
}) {
  return async () => {
    try {
      const label = selectedExportable.label || selectedExportable.title;
      const filename = `${label}.pdf`;
      const templateProps: TemplateProps = {
        formData,
        onChange: () => {
          /* no-op */
        },
        editMode: false,
      };

      const pdfBlob = await generatePDF(
        selectedExportable.Component,
        templateProps,
        {
          filename,
          format: "letter",
          orientation: selectedExportable.pdfOptions.orientation,
        },
      );

      // Create a URL for the blob and trigger download
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
}

export function getNextButtonHandler() {
  // TODO: This will be properly implemented in a future ticket
  return () => {
    /* no-op */
  };
}

export function getPreviousButtonHandler() {
  // TODO: This will be properly implemented in a future ticket
  return () => {
    /* no-op */
  };
}
